import * as React from "react"
import { LogOut, ChevronDown } from "lucide-react"
import { useAuth } from "@/lib/auth/AuthContext"
import { Button } from "@/shared/ui/atoms/Button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/atoms/Popover"
import { Separator } from "@/shared/ui/atoms/Separator"

export function UserMenu() {
  const { user, logout } = useAuth()
  const [open, setOpen] = React.useState(false)

  if (!user) return null

  const userInitial = user.username ? user.username.charAt(0).toUpperCase() : "U"

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex h-9 items-center gap-2 rounded-full border border-border/80 bg-background/50 px-2.5 py-1 text-sm font-medium hover:bg-muted/80 focus-visible:ring-1 focus-visible:ring-ring active:scale-[0.98] transition-all"
          aria-label="Menú de usuario"
        >
          <div className="flex size-6 items-center justify-center rounded-full bg-primary text-[11px] font-semibold text-primary-foreground select-none">
            {userInitial}
          </div>
          <span className="hidden max-w-[120px] truncate sm:inline-block text-xs font-medium">
            {user.username}
          </span>
          <ChevronDown className="size-3 text-muted-foreground transition-transform duration-200" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-56 p-2 shadow-lg">
        <div className="flex items-center gap-3 p-2">
          <div className="flex size-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground select-none">
            {userInitial}
          </div>
          <div className="flex flex-col min-w-0">
            <p className="text-xs font-semibold truncate leading-tight">{user.username}</p>
            <p className="text-[11px] text-muted-foreground truncate leading-tight mt-0.5">{user.email}</p>
          </div>
        </div>

        <Separator className="my-1.5" />

        <Button
          variant="ghost"
          size="sm"
          className="w-full justify-start gap-2 text-xs font-medium text-destructive hover:bg-destructive/10 hover:text-destructive active:bg-destructive/15 transition-colors"
          onClick={() => {
            setOpen(false)
            logout()
          }}
        >
          <LogOut className="size-3.5" />
          Cerrar sesión
        </Button>
      </PopoverContent>
    </Popover>
  )
}
